/* Fransk katalog for locale-pension-invoice-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'otp.sourceRequired': 'Document de la boîte de réception ou justificatif existant',
  'otp.positivePremium': 'Prime de retraite supérieure à 0 kr',
  'otp.completeBeforePreview': 'Complétez ou sélectionnez avant d\'afficher la proposition d\'imputation :',
  'otp.unlinked': 'Provisions de paie sans lien de facture',
  'otp.alreadyPosted': 'Charge et paiement déjà comptabilisés',
  'otp.noAccruals': 'Aucune provision de paie disponible. Les provisions déjà payées doivent être corrigées avant de pouvoir être liées à une facture.',
  'otp.inboxNotice': 'Ceci ressemble à une facture de retraite (OTP). Enregistrez-la via Retraite/OTP pour la rapprocher des provisions de paie et traiter correctement les cotisations patronales.',
  'otp.open': 'Ouvrir dans Retraite/OTP',
  'otp.dismiss': 'Ceci ne concerne pas l\'OTP',
  'otp.invoices': 'Factures de retraite et imputation',
  'otp.register': 'Enregistrer une facture de retraite',
  'otp.flow': 'Liez d\'abord la facture aux provisions de paie. Le paiement est enregistré une seule fois sur la facture. Les cotisations patronales suivent le mois de paiement effectif.',
  'otp.invoice': 'Facture',
  'otp.actual': 'Coût réel',
  'otp.accrued': 'Provision imputée',
  'otp.paid': 'Payé',
  'otp.remaining': 'Restant',
  'otp.aga': 'AGA traitées',
  'otp.reported': 'Déclaration enregistrée',
  'otp.notReported': 'Déclaration non enregistrée',
  'otp.reportingReview': 'L\'A-melding doit être examinée',
  'otp.reportingWarning': 'Une A-melding est déjà enregistrée pour le mois de paiement. Le paiement peut être enregistré, mais vous devez examiner et, si nécessaire, corriger l\'A-melding avec la base mise à jour de retraite et d\'AGA. La déclaration précédente n\'est pas modifiée automatiquement.',
  'otp.annulled': 'Lien annulé',
  'otp.details': 'Voir les détails',
  'otp.document': 'Document de la boîte de réception',
  'otp.existing': 'Lier à un justificatif existant',
  'otp.supplierName': 'Fournisseur',
  'otp.invoiceNumber': 'Numéro de facture',
  'otp.invoiceDate': 'Date de facture',
  'otp.dueDate': 'Date d\'échéance',
  'otp.date': 'Date d\'imputation',
  'otp.premium': 'Prime de retraite de l\'employeur',
  'otp.administration': 'Gestion de la retraite (hors TVA)',
  'otp.components': 'Confirmez que les montants concernent la prime de l\'employeur et, le cas échéant, la gestion du régime de retraite, hors TVA. La part salariale, les frais de transfert et les autres éléments doivent être examinés séparément avant d\'utiliser ce processus.',
  'otp.selectAccruals': 'Sélectionnez les provisions de paie couvertes par la facture',
  'otp.preview': 'Afficher la proposition d\'imputation',
  'otp.difference': 'Écart par rapport à la provision',
  'otp.existingPreview': 'L\'achat et le paiement existants sont conservés. Seules l\'imputation et une éventuelle reclassification sont affichées ci-dessous. Un montant positif est un débit, un montant négatif un crédit.',
  'otp.newPreview': 'La facture est comptabilisée sur 5950 en contrepartie des dettes fournisseurs 2400. L\'imputation des provisions antérieures est affichée ci-dessous. Un montant positif est un débit, un montant négatif un crédit. Le paiement est enregistré séparément.',
  'otp.confirm': 'Confirmer la facture et l\'imputation',
  'otp.saved': 'L\'enregistrement OTP a été sauvegardé.',
  'otp.purchasePosting': 'Voir le justificatif d\'achat',
  'otp.allocationPosting': 'Voir l\'imputation',
  'otp.paymentDocumented': 'N\'enregistrez qu\'un paiement documenté qui n\'est pas déjà comptabilisé. Aucun virement bancaire n\'est effectué.',
  'otp.reversePayment': 'Annuler le paiement',
  'otp.annulLink': 'Annuler l\'imputation',
  'otp.annulExplanation': 'L\'imputation et les AGA associées sont contre-passées. La facture d\'achat et le paiement sont conservés. Liez ensuite à nouveau la facture aux bonnes provisions. Cela ne modifie aucun virement bancaire.',
});
